document.addEventListener('DOMContentLoaded', () => {
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const route = (path) => `${shopRoot}${path}`.replace(/\/+/g, '/');

  // Source of truth for CritterMode package pricing. These are the real Shopify variants.
  const CM_VARIANTS = [
    { id: 60389198004305, style: 'Centipede', package: '1 Costume', units: 1, priceCents: 3499 },
    { id: 60393528721489, style: 'Centipede', package: '2 Costumes', units: 2, priceCents: 5999 },
    { id: 60393528754257, style: 'Centipede', package: '3 Costumes', units: 3, priceCents: 7999 },
    { id: 60389198037073, style: 'Cockroach', package: '1 Costume', units: 1, priceCents: 3499 },
    { id: 60393528787025, style: 'Cockroach', package: '2 Costumes', units: 2, priceCents: 5999 },
    { id: 60393528819793, style: 'Cockroach', package: '3 Costumes', units: 3, priceCents: 7999 },
    { id: 60389198069841, style: 'Spider', package: '1 Costume', units: 1, priceCents: 3499 },
    { id: 60393528852561, style: 'Spider', package: '2 Costumes', units: 2, priceCents: 5999 },
    { id: 60393528885329, style: 'Spider', package: '3 Costumes', units: 3, priceCents: 7999 },
    { id: 60389198102609, style: 'Dinosaur', package: '1 Costume', units: 1, priceCents: 3499 },
    { id: 60393528918097, style: 'Dinosaur', package: '2 Costumes', units: 2, priceCents: 5999 },
    { id: 60393528950865, style: 'Dinosaur', package: '3 Costumes', units: 3, priceCents: 7999 },
    { id: 60389198135377, style: 'Lobster', package: '1 Costume', units: 1, priceCents: 3499 },
    { id: 60393528983633, style: 'Lobster', package: '2 Costumes', units: 2, priceCents: 5999 },
    { id: 60393529016401, style: 'Lobster', package: '3 Costumes', units: 3, priceCents: 7999 },
    { id: 60389198168145, style: 'Cowboy', package: '1 Costume', units: 1, priceCents: 3499 },
    { id: 60393529049169, style: 'Cowboy', package: '2 Costumes', units: 2, priceCents: 5999 },
    { id: 60393529081937, style: 'Cowboy', package: '3 Costumes', units: 3, priceCents: 7999 }
  ];

  const byVariantId = new Map(CM_VARIANTS.map((variant) => [String(variant.id), variant]));
  const variantsByStyle = new Map();
  CM_VARIANTS.forEach((variant) => {
    if (!variantsByStyle.has(variant.style)) variantsByStyle.set(variant.style, []);
    variantsByStyle.get(variant.style).push(variant);
  });

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  async function jsonFetch(url, options = {}) {
    const response = await fetch(url, {
      ...options,
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {})
      }
    });
    if (!response.ok) {
      let message = `Request failed (${response.status})`;
      try {
        const data = await response.json();
        message = data.description || data.message || message;
      } catch (e) {}
      throw new Error(message);
    }
    return response.json();
  }

  function packageValueFromNumber(value) {
    const number = String(value || '').match(/\d+/)?.[0] || '1';
    if (number === '3') return '3 Costumes';
    if (number === '2') return '2 Costumes';
    return '1 Costume';
  }

  // Featured product: submit the exact Shopify package variant, never quantity 2/3 of the $34.99 variant.
  document.querySelectorAll('[data-cm-product]').forEach((root) => {
    const selectors = [...root.querySelectorAll('[data-option-index]')];
    const styleButtons = [...root.querySelectorAll('[data-style-button]')];
    const packageRadios = [...root.querySelectorAll('[data-qty-choice], [data-package-choice]')];
    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('.cm-starting strong, [data-product-price]');
    const add = root.querySelector('[data-add-button]');
    const image = root.querySelector('[data-product-image]');
    const qtyInput = root.querySelector('[data-quantity-input]');
    const prevButton = root.querySelector('[data-style-prev]');
    const nextButton = root.querySelector('[data-style-next]');
    const form = root.querySelector('form');

    const optionName = (selector) => (selector?.dataset?.optionName || '').trim().toLowerCase();
    const styleSelect = selectors.find((s) => optionName(s).includes('style') || optionName(s).includes('transformation')) || selectors[0];
    const packageSelect = selectors.find((s) => optionName(s).includes('package') || optionName(s).includes('bundle') || optionName(s) === 'pack');

    function selectedPackageValue() {
      if (packageSelect) return packageSelect.value;
      const checked = packageRadios.find((radio) => radio.checked);
      return checked ? (checked.dataset.packageValue || packageValueFromNumber(checked.value)) : '1 Costume';
    }

    function exactVariant() {
      if (!styleSelect) return null;
      return CM_VARIANTS.find((variant) => variant.style === styleSelect.value && variant.package === selectedPackageValue()) || null;
    }

    function syncStyleUI() {
      if (!styleSelect) return;
      styleButtons.forEach((button) => {
        const active = (button.dataset.styleValue || '') === styleSelect.value;
        button.classList.toggle('is-active', active);
        const input = button.querySelector('input');
        if (input) input.checked = active;
        if (active && image && button.dataset.image) image.src = button.dataset.image;
      });
    }

    function syncPackageUI() {
      const selected = selectedPackageValue();
      packageRadios.forEach((radio) => {
        const value = radio.dataset.packageValue || packageValueFromNumber(radio.value);
        const active = value === selected;
        radio.checked = active;
        const card = radio.closest('.cm-package');
        if (card) card.classList.toggle('is-active', active);
      });
    }

    function syncVariant() {
      const variant = exactVariant();
      syncStyleUI();
      syncPackageUI();
      if (qtyInput) qtyInput.value = '1';
      if (!variant) {
        if (add) {
          add.disabled = true;
          add.textContent = 'UNAVAILABLE';
        }
        return;
      }
      if (idInput) idInput.value = String(variant.id);
      if (price) price.textContent = money(variant.priceCents);
      if (add) {
        add.disabled = false;
        add.textContent = 'ADD TO CART →';
      }
    }

    styleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!styleSelect) return;
        const value = button.dataset.styleValue || '';
        const option = [...styleSelect.options].find((candidate) => candidate.value === value || candidate.text === value);
        if (!option) return;
        styleSelect.value = option.value;
        syncVariant();
      });
    });

    packageRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        const packageValue = radio.dataset.packageValue || packageValueFromNumber(radio.value);
        if (packageSelect) {
          const option = [...packageSelect.options].find((candidate) => candidate.value === packageValue || candidate.text === packageValue);
          if (option) packageSelect.value = option.value;
        }
        if (qtyInput) qtyInput.value = '1';
        syncVariant();
      });
    });

    selectors.forEach((selector) => selector.addEventListener('change', syncVariant));

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const variant = exactVariant();
        if (!variant || !add) return;

        add.disabled = true;
        const originalLabel = add.textContent;
        add.textContent = 'ADDING…';
        if (qtyInput) qtyInput.value = '1';
        if (idInput) idInput.value = String(variant.id);

        try {
          await jsonFetch(route('cart/add.js'), {
            method: 'POST',
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
          });
          window.location.assign(route('cart'));
        } catch (error) {
          console.error('CritterMode add-to-cart error:', error);
          add.disabled = false;
          add.textContent = originalLabel;
          window.alert(error.message || 'We could not add that package. Please try again.');
        }
      });
    }

    function cycleStyle(step) {
      if (!styleButtons.length) return;
      const currentIndex = Math.max(0, styleButtons.findIndex((button) => button.classList.contains('is-active')));
      const nextIndex = (currentIndex + step + styleButtons.length) % styleButtons.length;
      styleButtons[nextIndex].click();
    }

    if (prevButton) prevButton.addEventListener('click', () => cycleStyle(-1));
    if (nextButton) nextButton.addEventListener('click', () => cycleStyle(1));
    syncVariant();
  });

  document.querySelectorAll('[data-transform-style]').forEach((card) => {
    card.addEventListener('click', () => {
      const style = (card.dataset.transformStyle || '').trim();
      const target = document.querySelector('[data-featured-buy]');
      if (!target) return;
      const matchingButton = [...target.querySelectorAll('[data-style-button]')].find(
        (button) => (button.dataset.styleValue || '').trim().toLowerCase() === style.toLowerCase()
      );
      if (matchingButton) matchingButton.click();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const main = button.closest('[data-product-gallery]')?.querySelector('[data-gallery-main]');
      if (main && button.dataset.src) main.src = button.dataset.src;
    });
  });

  // Cart pricing: 1 Costume x 2 automatically becomes the real 2 Costumes / $59.99 variant.
  const cartForm = document.querySelector('.cm-cart-page form[action*="/cart"]');
  const cartPage = document.querySelector('.cm-cart-page');

  if (cartPage) {
    async function getCart() {
      return jsonFetch(route('cart.js'), { method: 'GET' });
    }

    async function updateCart(updates) {
      if (!Object.keys(updates).length) return null;
      return jsonFetch(route('cart/update.js'), {
        method: 'POST',
        body: JSON.stringify({ updates })
      });
    }

    async function addItems(items) {
      if (!items.length) return null;
      return jsonFetch(route('cart/add.js'), {
        method: 'POST',
        body: JSON.stringify({ items })
      });
    }

    function desiredPackages(style, totalUnits) {
      const styleVariants = variantsByStyle.get(style) || [];
      const byUnits = new Map(styleVariants.map((variant) => [variant.units, variant]));
      const desired = new Map();
      let remaining = Math.max(0, Number(totalUnits) || 0);

      [3, 2, 1].forEach((units) => {
        const variant = byUnits.get(units);
        if (!variant || remaining < units) return;
        const quantity = Math.floor(remaining / units);
        if (quantity > 0) {
          desired.set(String(variant.id), quantity);
          remaining -= quantity * units;
        }
      });
      return desired;
    }

    function sameDistribution(current, desired) {
      const ids = new Set([...current.keys(), ...desired.keys()]);
      for (const id of ids) {
        if ((current.get(id) || 0) !== (desired.get(id) || 0)) return false;
      }
      return true;
    }

    async function normalizeCritterModeCart(cart) {
      if (!cart || !Array.isArray(cart.items)) return false;
      const groups = new Map();

      cart.items.forEach((item) => {
        const variant = byVariantId.get(String(item.variant_id || item.id));
        if (!variant) return;
        if (!groups.has(variant.style)) {
          groups.set(variant.style, { totalUnits: 0, items: [], current: new Map() });
        }
        const group = groups.get(variant.style);
        const quantity = Number(item.quantity || 0);
        group.totalUnits += variant.units * quantity;
        group.items.push(item);
        group.current.set(String(variant.id), (group.current.get(String(variant.id)) || 0) + quantity);
      });

      const removals = {};
      const additions = [];
      let changed = false;

      for (const [style, group] of groups.entries()) {
        const desired = desiredPackages(style, group.totalUnits);
        if (sameDistribution(group.current, desired)) continue;
        changed = true;
        group.items.forEach((item) => { removals[item.key] = 0; });
        desired.forEach((quantity, id) => {
          if (quantity > 0) additions.push({ id: Number(id), quantity });
        });
      }

      if (!changed) return false;
      await updateCart(removals);
      await addItems(additions);
      return true;
    }

    async function applyVisibleCartQuantities(cart) {
      if (!cartForm || !cart || !Array.isArray(cart.items)) return;
      const quantityInputs = [...cartForm.querySelectorAll('input[name="updates[]"]')];
      if (!quantityInputs.length) return;
      const updates = {};
      quantityInputs.forEach((input, index) => {
        const item = cart.items[index];
        if (!item) return;
        updates[item.key] = Math.max(0, parseInt(input.value, 10) || 0);
      });
      await updateCart(updates);
    }

    if (cartForm) {
      cartForm.addEventListener('submit', async (event) => {
        const submitter = event.submitter;
        if (!submitter || (submitter.name !== 'update' && submitter.name !== 'checkout')) return;
        event.preventDefault();
        submitter.disabled = true;
        const goToCheckout = submitter.name === 'checkout';

        try {
          let cart = await getCart();
          await applyVisibleCartQuantities(cart);
          cart = await getCart();
          await normalizeCritterModeCart(cart);
          window.location.assign(goToCheckout ? route('checkout') : route('cart'));
        } catch (error) {
          console.error('CritterMode cart pricing error:', error);
          submitter.disabled = false;
          window.alert('We could not update the package pricing. Please refresh and try again.');
        }
      });
    }

    (async () => {
      try {
        const cart = await getCart();
        const changed = await normalizeCritterModeCart(cart);
        if (changed) window.location.replace(route('cart'));
      } catch (error) {
        console.error('CritterMode automatic package pricing error:', error);
      }
    })();
  }
});